<template>
  <nav class="c-side-info">
    <div class="c-side-info__wrap">
      <div class="c-side-info__lists">
        <ul class="c-side-info__list">
          <li class="c-side-info__list__title">カテゴリ</li>
          <li
            @click="saveCategoryToStore('', 'all')"
          >
            <router-link class="c-side-info__list__item" to="/notifications">すべて</router-link>
          </li>
          <li
            v-for="value in filterTitle"
            :key="value.id"
            @click="saveCategoryToStore(value.id, 'name')"
          >
            <router-link class="c-side-info__list__item" to="/notifications">{{ value.name }}</router-link>
          </li>
        </ul>

        <ul>
          <li class="c-side-info__list__title">過去のお知らせ</li>

          <li
            v-for="value in filterYear"
            :key="value.id"
            @click="saveCategoryToStore(value.year, 'year')"
          >
            <router-link to="/notifications" class="c-side-info__list__item"
              >{{ value.year }}年度</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { SAVE_CATEGORY_ALL, SAVE_CATEGORY_YEAR, SAVE_CATEGORY_NAME } from '@/store/modules/bs_inf/actions'

export default {
  name: 'LeftBar',
  data() {
    return {
      isMarginClass: false,
      sideMenu: []
    }
  },
  computed: {
    filterTitle() {
      return this.sideMenu.filter((item) => item.name)
    },
    filterYear() {
      return this.sideMenu.filter((item) => item.year)
    }
  },
  methods: {
    saveCategoryToStore(selectedId, controlId) {
      if (controlId === 'all') {
        // this.$store.commit('information/categoryAll', selectedId)
        return this.$store.dispatch(SAVE_CATEGORY_ALL, selectedId)
      } else if (controlId === 'name') {
        // this.$store.commit('information/categoryName', selectedId)
        return this.$store.dispatch(SAVE_CATEGORY_NAME, selectedId)
      } else {
        // this.$store.commit('information/categoryYear', selectedId)
        return this.$store.dispatch(SAVE_CATEGORY_YEAR, selectedId)
      }
    }
  },
  async mounted() {
    const res = await this.$repositories('cms').getNewsMenu()
    this.sideMenu = res.data.objects[0].data
  }
}
</script>

<style lang="scss">
  @import './styles.scss';
</style>
